<view-file
  *ngIf="documentSearchParams.identifierId"
  [parentCategory]="'Contract'"
  [searchParams]="documentSearchParams"
  [title]="'Documents'"
  [tabKey]="'documents-tab'"
></view-file>
